module.exports = __webpack_public_path__ + "img/slider.d5617cd6.jpg";